module.exports = __webpack_public_path__ + "static/media/foto4.9e76c7a2.jpg";